





























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';

import { getAgoString } from '@/utils/general';

@Component
export default class SnippetCard extends Vue {
	@State private launcherState !: any;
	@State private storeInputText !: any;
	@State private dataPanelSide!: string;
	@Action private modifyExtractor!: any;

	@Prop() private item !: any;

	private get name() {
		if (!!this.item.instanceProps) {
			return this.item.instanceProps.name;
		} else {
			return null;
		} 
	}

	private get message() {
		if (!!this.item.args) {
			return this.item.args.message;
		} else {
			return null;
		} 
	}

	private get createdAt() {
		if (!!this.item.instanceProps) {
			return getAgoString(this.item.instanceProps.createdAt);
		} else {
			return null;
		} 
	}

	private get timesUsed() {
		if (!!this.item.instanceProps) {
			return this.item.instanceProps.timesUsed;
		} else {
			return null;
		}
	}

	private parseContentForReplacements(message: string) {
		if (!message) {
			return [];
		}

		let firstIndex = 0;
		let copyMsg = message;
		const chunkedMessage = [];
		while (firstIndex !== -1) {
			firstIndex = copyMsg.search(/\{([^}]+)\}/g);
			if (firstIndex !== -1) {
				const leading = copyMsg.slice(0, firstIndex);
				const toReplace = copyMsg.match(/\{([^}]+)\}/g)[0];
				copyMsg = copyMsg.slice(firstIndex + toReplace.length);
				chunkedMessage.push({
					replace: false,
					value: leading
				});
				chunkedMessage.push({
					replace: true,
					value: toReplace
				});
			} else {
				chunkedMessage.push({
					replace: false,
					value: copyMsg
				});
			}
		}
		return chunkedMessage;
	}

	private templateReplace( text: string, replacementDict: any ) {
		return text
		.replace(
			/\{([^}]+)\}/g,
			( m: any , key: any ) => {
				return replacementDict !== undefined &&
				replacementDict.hasOwnProperty( key ) ? replacementDict[ key ] : '[No Value]';
			}
		);
	}

}

